import { handleErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { GlobalAppPropsInfo } from '@juvare/common-web-ui/GlobalApp';
import { useUserClient } from '@juvare/platform-sdk-react/ui/hooks';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AppContext } from '../components/Context';

export function useSwitchUserInfo(): GlobalAppPropsInfo | undefined {
    const { t } = useTranslation();
    const appContext = React.useContext(AppContext);
    const userClient = useUserClient();
    if (appContext.switchUserPrev) {
        return {
            infoMessage: t('appHeader.toolbar.switchMessage', { displayName: appContext.userState?.displayName }),
            infoActionLabel: t('appHeader.toolbar.switchBack'),
            infoActionOnClick: () => {
                userClient
                    .switchBackUser()
                    .then((response) => window.location.assign(response.loginSuccessUrl))
                    .catch(handleErrorDialog);
            },
        };
    } else {
        return undefined;
    }
}
